import { Component, OnInit } from '@angular/core'

@Component({
  standalone: false,
  selector: 'vs-create-order-widget',
  templateUrl: './create-order-widget.component.html',
  styleUrls: ['./create-order-widget.component.scss'],
})
export class CreateOrderWidgetComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
    sessionStorage['selectedIndex'] = 0;
  }
}
